import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { HelmetProvider } from 'react-helmet-async';
render(<HelmetProvider data-id="element-90">
    <AppRouter data-id="element-91" />
  </HelmetProvider>, document.getElementById('root'));